import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { minTablet, minDesktop } from '../styles/breakpoints';
import { GrayBack, White } from '../styles/colors';

import RhombusTopImg from '../rhombus/rhombus-flat-top.svg';
import RhombusBottomImg from '../rhombus/rhombus-flat-bottom.svg';

const RHOMBUS_HEIGHT = 64;
const DESKTOP_WIDTH = 1180;

const Main = styled.main`
  margin-left: 25px;
  margin-right: 25px;

  ${minTablet} {
    margin-left: 40px;
    margin-right: 40px;
  }

  ${minDesktop} {
    width: ${DESKTOP_WIDTH}px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    top: 0;
    left: -30px;

    background-color: ${GrayBack};

    ::before, ::after {
      content: '';
      display: block;
      left: 0;
      right: 0;
      height: ${RHOMBUS_HEIGHT}px;
      background-color: ${White};
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }

    ::before {
      top: 0;
      background-image: url(${RhombusTopImg});
    }

    ::after {
      bottom: 0;
      background-image: url(${RhombusBottomImg});
    }
  }
`;

const PageMainLayout = ({ children }) => (
  <Main>
    { children }
  </Main>
);

PageMainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageMainLayout;



// WEBPACK FOOTER //
// ./src/components/PageMainLayout/PageMainLayout.js